import React from "react";
import {
  Card,
  CardBody,
  CardImg,
  CardTitle,
  CardSubtitle,
  CardText,
  CardDeck,
  Col,
} from "reactstrap";
import { FormattedMessage } from "react-intl";
import useAuthStore from "../../stores/useAuthStore";
import { useNavigate } from "react-router-dom";

function SuperDash() {
  const navigate = useNavigate();
  const roles = useAuthStore((state) => state.roles);

  return (
    <div className="animated fadeIn">
      <div className="d-flex">
        <Col sm="12" md="12" lg="12" xl="12">
          <CardDeck className="d-flex gap-3">
            <Card
              onClick={() => navigate("/superuser/schools")}
              style={{ cursor: "pointer" }}
            >
              <CardImg
                top
                width="100%"
                src="img/Elever_img.jpg"
                alt="Card image cap"
              />
              <CardBody>
                <CardTitle className="text-warning">
                  <strong>
                    <FormattedMessage id="Navigation_Superuser_Schools" />
                  </strong>
                </CardTitle>
                <CardSubtitle />
                <CardText>
                  <FormattedMessage id="AdministerSchoolsText" />
                </CardText>
              </CardBody>
            </Card>

            {roles === "Superuser" && (
              <Card
                onClick={() => navigate("/superuser/courses")}
                style={{ cursor: "pointer" }}
              >
                <CardImg
                  top
                  width="100%"
                  src="img/Kurser_img.jpg"
                  alt="Card image cap"
                />
                <CardBody>
                  <CardTitle className="text-danger">
                    <strong>
                      <FormattedMessage id="CoursesModulesAndLicenses" />
                    </strong>
                  </CardTitle>
                  <CardSubtitle />
                  <CardText>
                    <FormattedMessage id="AdministerCoursesText" />
                  </CardText>
                </CardBody>
              </Card>
            )}

            <Card
              onClick={() =>
                navigate("/superuser/invoicehistory")
              }
              style={{ cursor: "pointer" }}
            >
              <CardImg
                top
                width="100%"
                src="img/Faktura_img.jpg"
                alt="Card image cap"
              />
              <CardBody>
                <CardTitle className="text-primary">
                  <strong>
                    <FormattedMessage id="Navigation_Teacher_Invoice_History" />
                  </strong>
                </CardTitle>
                <CardSubtitle />
                <CardText />
              </CardBody>
            </Card>

            {roles === "Superuser" && (
              <Card
                onClick={() => navigate("/superuser/users")}
                style={{ cursor: "pointer" }}
              >
                <CardImg
                  top
                  width="100%"
                  src="img/Elever_img.jpg"
                  alt="Card image cap"
                />
                <CardBody>
                  <CardTitle className="text-secondary">
                    <strong>
                      <FormattedMessage id="Navigation_Superuser_Users" />
                    </strong>
                  </CardTitle>
                  <CardSubtitle />
                  <CardText>
                    <FormattedMessage id="UserAdministrationText" />
                  </CardText>
                </CardBody>
              </Card>
            )}
            <Card
              onClick={() =>
                navigate("/superuser/notifications")
              }
              style={{ cursor: "pointer" }}
            >
              <CardImg
                top
                width="100%"
                src="img/tembg.jpg"
                alt="Card image cap"
              />
              <CardBody>
                <CardTitle style={{ color: "#12445A" }}>
                  <strong>
                    <FormattedMessage id="Navigation_Notifications" />
                  </strong>
                </CardTitle>
                <CardSubtitle />
                <CardText>
                  <FormattedMessage id="NotificationAdministrationText" />
                </CardText>
              </CardBody>
            </Card>
            <Card
              onClick={() => navigate("/superuser/licenses")}
              style={{ cursor: "pointer" }}
            >
              <CardImg
                top
                width="100%"
                src="img/templicenses.jpg"
                alt="Card image cap"
              />
              <CardBody>
                <CardTitle style={{ color: "#12445A" }}>
                  <strong>
                    <FormattedMessage id="LicenseManagement" />
                  </strong>
                </CardTitle>
                <CardSubtitle />
                <CardText>
                  <FormattedMessage id="LicenseAdministrationText" />
                </CardText>
              </CardBody>
            </Card>
          </CardDeck>
        </Col>
      </div>
    </div>
  );
}

export default SuperDash;
